import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
            {/* Column 1: Brand */}
            <div>
              <div className="mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_behringer-school/artifacts/ej9d0d4x_LOGO%20WING%20ACADEMY%20BRANCA.png" 
                  alt="WING ACADEMY BRASIL" 
                  className="h-16 md:h-20 w-auto"
                />
              </div>
              <p className="text-gray-400 text-sm mb-4">
                Treinamento oficial para Console Behringer WING com instrutores certificados.
              </p>
              {/* Social Links */}
              <div className="flex gap-3">
                <a
                  href="#"
                  className="w-10 h-10 bg-white/5 hover:bg-yellow-500/20 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label="Facebook"
                >
                  <Facebook className="w-5 h-5 text-gray-400 hover:text-yellow-400" />
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-white/5 hover:bg-yellow-500/20 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label="Instagram"
                >
                  <Instagram className="w-5 h-5 text-gray-400 hover:text-yellow-400" />
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-white/5 hover:bg-yellow-500/20 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label="YouTube"
                >
                  <Youtube className="w-5 h-5 text-gray-400 hover:text-yellow-400" />
                </a>
              </div>
            </div>

            {/* Column 2: Links Rápidos */}
            <div>
              <h3 className="text-white font-bold mb-4">Links Rápidos</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#sobre" className="text-gray-400 hover:text-yellow-400 transition-colors duration-300 text-sm">
                    Sobre o Curso
                  </a>
                </li>
                <li>
                  <a href="#modulos" className="text-gray-400 hover:text-yellow-400 transition-colors duration-300 text-sm">
                    Módulos
                  </a>
                </li>
                <li>
                  <a href="#bonus" className="text-gray-400 hover:text-yellow-400 transition-colors duration-300 text-sm">
                    Bônus
                  </a>
                </li>
                <li>
                  <a href="#depoimentos" className="text-gray-400 hover:text-yellow-400 transition-colors duration-300 text-sm">
                    Depoimentos
                  </a>
                </li>
                <li>
                  <a href="/quiz" className="text-yellow-400 hover:text-yellow-300 transition-colors duration-300 text-sm font-medium">
                    🎯 Fazer Quiz
                  </a>
                </li>
                <li>
                  <Link to="/downloads" data-testid="footer-downloads-link" className="text-yellow-400 hover:text-yellow-300 transition-colors duration-300 text-sm font-medium flex items-center gap-1">
                    📥 Central de Downloads
                  </Link>
                </li>
                <li>
                  <Link to="/blog" data-testid="footer-blog-link" className="text-yellow-400 hover:text-yellow-300 transition-colors duration-300 text-sm font-medium">
                    📝 Blog
                  </Link>
                </li>
                <li>
                  <Link to="/sobre" data-testid="footer-sobre-link" className="text-gray-400 hover:text-yellow-400 transition-colors duration-300 text-sm">
                    Sobre o Instrutor
                  </Link>
                </li>
                <li>
                  <Link to="/politica-de-privacidade" className="text-gray-400 hover:text-yellow-400 transition-colors duration-300 text-sm">
                    Política de Privacidade
                  </Link>
                </li>
                <li>
                  <Link to="/solicitar-dados" data-testid="footer-lgpd-link" className="text-gray-400 hover:text-yellow-400 transition-colors duration-300 text-sm">
                    Solicitar meus dados (LGPD)
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3: Contato */}
            <div>
              <h3 className="text-white font-bold mb-4">Contato</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <Mail className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                  <a href="mailto:wingacademybrasil@gmail.com" className="text-gray-400 hover:text-green-400 transition-colors duration-300 text-sm">
                    wingacademybrasil@gmail.com
                  </a>
                </li>
                <li className="flex items-start gap-2">
                  <Phone className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                  <a href="tel:+5521999568656" className="text-gray-400 hover:text-green-400 transition-colors duration-300 text-sm">
                    (21) 99956-8656
                  </a>
                </li>
                <li className="flex items-start gap-2">
                  <MapPin className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-400 text-sm">
                    Brasil
                  </span>
                </li>
              </ul>
            </div>

            {/* Column 4: Sobre */}
            <div>
              <h3 className="text-white font-bold mb-4">Sobre</h3>
              <p className="text-gray-400 text-sm mb-4">
                Somos parceiros oficiais da Behringer e oferecemos treinamentos presenciais e online para profissionais de áudio.
              </p>
              <div className="bg-yellow-500/10 border border-yellow-500/30 p-3 rounded-lg">
                <p className="text-yellow-400 text-xs font-semibold">
                  ⭐ Endorsee Oficial Behringer Brasil
                </p>
              </div>
            </div>
        </div>

        {/* Parceiros Oficiais */}
        <div
          data-testid="footer-partners"
          className="border-t border-white/10 pt-8 pb-8 mb-4"
        >
          <p className="text-center text-gray-500 text-xs uppercase tracking-[0.2em] mb-6">
            Parceiros Oficiais
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-12 md:gap-16">
            <img
              src="https://customer-assets.emergentagent.com/job_207ce1a1-cc0d-4cea-b992-9f78cf5204d4/artifacts/svtm2j4u_r5m1uacd_LOGO%20BEHRINGER%20PNG%20BRANCA.png"
              alt="Behringer — Parceiro Oficial"
              loading="lazy"
              className="h-7 sm:h-8 md:h-9 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
            />
            <img
              src="https://customer-assets.emergentagent.com/job_207ce1a1-cc0d-4cea-b992-9f78cf5204d4/artifacts/6uwr1lb7_ProShows-Logo-Vector.svg-.png"
              alt="Pro Shows — Parceiro Oficial"
              loading="lazy"
              className="h-7 sm:h-8 md:h-9 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
            />
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} WING ACADEMY BRASIL. Todos os direitos reservados.
            </p>
            <div className="flex gap-6">
              <Link
                to="/politica-de-privacidade"
                data-testid="footer-privacy-link"
                className="text-gray-500 hover:text-yellow-400 text-sm transition-colors duration-300"
              >
                Política de Privacidade (LGPD)
              </Link>
              <Link
                to="/politica-de-privacidade#contato"
                className="text-gray-500 hover:text-yellow-400 text-sm transition-colors duration-300"
              >
                Contato DPO
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
